module.exports = __webpack_public_path__ + "img/es-ga.ec306dbd.svg";